import { render } from "./PlaceOrder.vue?vue&type=template&id=287f33cd&scoped=true"
import script from "./PlaceOrder.vue?vue&type=script&lang=js"
export * from "./PlaceOrder.vue?vue&type=script&lang=js"

import "./PlaceOrder.vue?vue&type=style&index=0&id=287f33cd&lang=scss&scoped=true"

import exportComponent from "D:\\Word\\mingyou\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-287f33cd"]])

export default __exports__